import React, { useEffect } from 'react';

const Notification = ({ message, type = 'error', onClose, duration = 3000 }) => {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  const bgColors = {
    error: 'bg-red-50 border-red-500',
    success: 'bg-green-500 border-green-600',
    warning: 'bg-yellow-50 border-yellow-500',
    info: 'bg-blue-50 border-blue-500',
  };

  const inlineStyles = type === 'success' ? {
    backgroundColor: '#10b981', 
    borderLeft: '4px solid #059669', 
    color: '#ffffff', 
  } : {};

  const textColors = {
    error: 'text-red-800',
    success: 'text-white',
    warning: 'text-yellow-800',
    info: 'text-blue-800',
  };

  const iconColors = {
    error: 'text-red-600',
    success: 'text-white',
    warning: 'text-yellow-600',
    info: 'text-blue-600',
  };

  const icons = {
    error: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    success: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    warning: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
      </svg>
    ),
    info: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  };

  return (
    <div
      className={`fixed top-4 right-4 z-50 ${bgColors[type]} border-l-4 ${textColors[type]} shadow-xl rounded-lg p-4 min-w-[300px] max-w-md transform transition-all duration-300 ease-in-out animate-slide-in`}
      style={inlineStyles}
    >
      <div className="flex items-center">
        <div 
          className={`flex-shrink-0 ${iconColors[type]}`}
          style={type === 'success' ? { color: '#ffffff' } : {}}
        >
          {icons[type]}
        </div>
        <div className="ml-3 flex-1">
          <p 
            className={`text-sm font-semibold ${textColors[type]}`}
            style={type === 'success' ? { color: '#ffffff' } : {}}
          >
            {message}
          </p>
        </div>
        <button
          onClick={onClose}
          className={`ml-4 flex-shrink-0 ${textColors[type]} hover:opacity-70 focus:outline-none transition-opacity`}
          style={type === 'success' ? { color: '#ffffff' } : {}}
          aria-label="Close notification"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Notification;

